<template lang="">
  <div class="chart-box">
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index, item)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
import { loadChart } from "../charts/cyqkData";
import { timerMixin } from "@/util/mixin/timerMixin";
import { getIndustrySituation } from "@/api/cyzl";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["面积", "产量", "产值"],
      active: 0,
      selectName: "面积",
      bfList: [], //保存所有数据
      yearList: []
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getAllData();
    // this.getData();
    // this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, this.typeList[active], false);
    },
    changeType(index, name, clearT = true) {
      this.active = index;
      this.selectName = name;
      // this.getData();
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    },
    getAllData() {
      getIndustrySituation().then(res => {
        if (res) {
          let yearList = [];
          let mjList = []; //面积
          let clList = []; //产量
          let czList = []; //产值
          res.data.forEach(ele => {
            yearList.push(ele.year_);
            mjList.push(Number(ele.area_));
            clList.push(Number(ele.yield_));
            czList.push(Number(ele.outputValue_));
          });
          this.yearList = yearList;
          this.bfList = [];
          this.bfList.push(mjList);
          this.bfList.push(clList);
          this.bfList.push(czList);

          this.initChart();
          this.startTimer();
        }
      });
    },
    initChart() {
      let min = 0; // min
      const resultArr = [this.typeList[this.active]];
      const bfData = [this.bfList[this.active]];
      const unit = ["万亩", "万吨", "亿元"];
      if (this.active === 0) {
        min = 80;
      }
      //  else if (this.active === 2) {
      //   // min = Math.floor(Math.min(...bfData));
      //   min = 0;
      // }

      loadChart(
        this.chart,
        resultArr,
        this.yearList,
        bfData,
        unit[this.active],
        min
      );
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.flex
  display flex
  justify-content center

.chart-box
  width 100%
  height 100%
  position relative
  .tab-box
    position absolute
    top 15px
    right 4%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
</style>
